class APIModel {
	 static HOST = "https://vmsuatsolution.azurewebsites.net/api/";
	 //static HOST = "https://vmssanchezsolution.azurewebsites.net/api/";
	 //static HOST = "https://vmsuat-sanchez-solution.azurewebsites.net/api/"
	//static HOST = "http://localhost:16250/api/";
	//static DEV_HOST = "localhost:16250/api/";
}
export default APIModel;



